<script setup lang="ts">
import { DEFAULT_MIN_READ_TEXT } from '@zyro-inc/site-modules/constants/siteModulesConstants';

defineProps({
	authorName: {
		type: String,
		default: '',
	},
	minutesAmount: {
		type: String,
		default: '0',
	},
	blogReadingTimeText: {
		type: String,
		default: '',
	},
	date: {
		type: String,
		default: '',
	},
	showAvatar: {
		type: Boolean,
		default: true,
	},
	showName: {
		type: Boolean,
		default: true,
	},
	showDate: {
		type: Boolean,
		default: true,
	},
	showMinutes: {
		type: Boolean,
		default: true,
	},
});
</script>

<template>
	<div class="blog-list-item-meta">
		<div class="font-secondary">
			<p
				v-show="showName"
				v-qa="'blog-author'"
				class="blog-list-item-meta__author-name"
			>
				{{ authorName }}
			</p>
			<p
				v-show="showDate || showMinutes"
				class="blog-list-item-meta__subtitle"
			>
				<span
					v-if="showDate && date"
					v-qa="'blog-list-item-date'"
				>
					{{ date }}
				</span>
				<span v-if="showMinutes">
					{{ `${minutesAmount} ${blogReadingTimeText || DEFAULT_MIN_READ_TEXT}` }}
				</span>
			</p>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import "@zyro-inc/site-modules/components/blocks/blog/BlockBlogFonts";

.blog-list-item-meta {
	color: var(--blog-post-header-text-color);
	opacity: 0.8;

	&__author-name {
		margin-bottom: 4px;
	}

	&__subtitle {
		span:nth-of-type(2)::before {
			content: " · ";
		}
	}
}
</style>
